import { render, staticRenderFns } from "./CommonError.vue?vue&type=template&id=147c8dde&"
import script from "./CommonError.vue?vue&type=script&lang=js&"
export * from "./CommonError.vue?vue&type=script&lang=js&"
import style0 from "./CommonError.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports